module.exports = {
  Character: {
    PluginName: "Personaje",
  },
};
